export const REQUEST_SET_PROGRAM_ITEM_REF: 'POOL_TRANSIENT_STATE/SET_PROGRAM_ITEM_REF' =
	'POOL_TRANSIENT_STATE/SET_PROGRAM_ITEM_REF';
export const REQUEST_UNSET_PROGRAM_ITEM_REF: 'POOL_TRANSIENT_STATE/UNSET_PROGRAM_ITEM_REF' =
	'POOL_TRANSIENT_STATE/UNSET_PROGRAM_ITEM_REF';
export const REQUEST_SET_OVERLAY_REF: 'POOL_TRANSIENT_STATE/SET_OVERLAY_REF' = 'POOL_TRANSIENT_STATE/SET_OVERLAY_REF';
export const REQUEST_UNSET_OVERLAY_REF: 'POOL_TRANSIENT_STATE/UNSET_OVERLAY_REF' =
	'POOL_TRANSIENT_STATE/UNSET_OVERLAY_REF';
export const REQUEST_UNSET_CURRENT_OVERLAY_REF: 'POOL_TRANSIENT_STATE/UNSET_CURRENT_OVERLAY_REF' =
	'POOL_TRANSIENT_STATE/UNSET_CURRENT_OVERLAY_REF';
export const REQUEST_ADD_PERSISTENT_FILTER: 'POOL_TRANSIENT_STATE/ADD_PERSISTENT_FILTER' =
	'POOL_TRANSIENT_STATE/ADD_PERSISTENT_FILTER';
export const REQUEST_REMOVE_PERSISTENT_FILTER: 'POOL_TRANSIENT_STATE/REMOVE_PERSISTENT_FILTER' =
	'POOL_TRANSIENT_STATE/REMOVE_PERSISTENT_FILTER';
export const REQUEST_SET_PERSISTENT_FILTER: 'POOL_TRANSIENT_STATE/SET_PERSISTENT_FILTER' =
	'POOL_TRANSIENT_STATE/SET_PERSISTENT_FILTER';
export const REQUEST_UNSET_PERSISTENT_FILTER: 'POOL_TRANSIENT_STATE/UNSET_PERSISTENT_FILTER' =
	'POOL_TRANSIENT_STATE/UNSET_PERSISTENT_FILTER';
export const REQUEST_UNSET_ALL_FILTERS: 'POOL_TRANSIENT_STATE/REQUEST_UNSET_ALL_FILTERS' =
	'POOL_TRANSIENT_STATE/REQUEST_UNSET_ALL_FILTERS';
export const REQUEST_SELECTED_ITEM: 'POOL_TRANSIENT_STATE/REQUEST_SELECTED_ITEM' =
	'POOL_TRANSIENT_STATE/REQUEST_SELECTED_ITEM';
export const REQUEST_SELECTED_ITEM_SUCCESS: 'POOL_TRANSIENT_STATE/REQUEST_SELECTED_ITEM_SUCCESS' =
	'POOL_TRANSIENT_STATE/REQUEST_SELECTED_ITEM_SUCCESS';
export const REQUEST_SELECTED_ITEM_FAILURE: 'POOL_TRANSIENT_STATE/REQUEST_SELECTED_ITEM_FAILURE' =
	'POOL_TRANSIENT_STATE/REQUEST_SELECTED_ITEM_FAILURE';
export const REQUEST_SET_DAY_REF: 'POOL_TRANSIENT_STATE/REQUEST_SET_DAY_REF' =
	'POOL_TRANSIENT_STATE/REQUEST_SET_DAY_REF';
export const REQUEST_UNSET_DAY_REF: 'POOL_TRANSIENT_STATE/REQUEST_UNSET_DAY_REF' =
	'POOL_TRANSIENT_STATE/REQUEST_UNSET_DAY_REF';
